import angular from 'angular';
import SpinnerComponent from './spinner.component';

export default angular
  .module('verifyApp.spinner', [])
  .component('spinner', SpinnerComponent)
  .name;



// WEBPACK FOOTER //
// ./client/components/spinner/index.js